/* @flow */

import React from 'react';

import { isAlwaysOnTitleBarEmpty } from '../functions.web';

// CUSTOM
import Button from '@atlaskit/button/standard-button';
import { dispatch } from '../../../customise/Utils';
import { StartRecordingDialog } from '../../../recording/components/Recording/web';
import { openDialog } from '../../../base/dialog';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { useSelector } from 'react-redux';
import { getLocalParticipant, PARTICIPANT_ROLE } from '../../../base/participants';
import { setEnableRecordingModal } from '../../../customise/redux/tool-webjam-v2/actions';
import { FEATURE_CUSTOM_REDUX_V2 } from '../../../customise/constant';
import { ct } from '../../../customise/constant-Utils';
// END

type Props = {

    /**
     * The children components.
     */
    children: React$Node,

    /**
     * Id of the component.
     */
    id?: string,

    /**
    * Whether this conference info container should be visible or not.
    */
    visible: boolean
}

// CUSTOM
// export default ({ visible, children, id }: Props) => (
//     <div
//         className = { `subject${isAlwaysOnTitleBarEmpty() ? '' : ' with-always-on'}${visible ? ' visible' : ''}` }
//         id = { id }>
//         <div className = { 'subject-info-container' }>
//             {children}
//         </div>
//     </div>
// );

export default ({ visible, children, id }: Props) => {

    let _isRecordingRunning = useSelector(state => state['features/recording'].sessionDatas.find(e => e.mode == JitsiRecordingConstants.mode.FILE
        && (e.status === JitsiRecordingConstants.status.ON || e.status === JitsiRecordingConstants.status.PENDING)))

    let _isStreamingRunning = useSelector(state => state['features/recording'].sessionDatas.find(e => e.mode == JitsiRecordingConstants.mode.STREAM
        && (e.status === JitsiRecordingConstants.status.ON || e.status === JitsiRecordingConstants.status.PENDING)))

    let localParticipant = useSelector(getLocalParticipant);
    let isModerator = Boolean(localParticipant?.role === PARTICIPANT_ROLE.MODERATOR);
    const { disableRecIcon } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V2]);
    const recIconAction = () => {
        if (isModerator) {
            dispatch(setEnableRecordingModal(Math.round(new Date().getTime() / 1000)))
            dispatch(openDialog(StartRecordingDialog))
        }
    }

    const renderContent = () => {
        if (!_isStreamingRunning) {
            if (!_isRecordingRunning && isModerator && !disableRecIcon) {
                return <Button
                    className='custom-rec-icon'
                    onClick={() => recIconAction('start')}
                >{ct("rta-trmc.toolBox.startRecording")}</Button>
            } else {
                return null;
            }
        }
    }

    return (
        <>
            <div
                className={`${id == "alwaysVisible" ? "top-container-cust" : " "}   subject${isAlwaysOnTitleBarEmpty() ? '' : ' with-always-on'}${visible ? ' visible' : (!_isRecordingRunning && isModerator && !disableRecIcon ? " visible " : "a")
                    }`}
                id={id}>
                <div className={'subject-info-container'}>
                    {renderContent()}
                    {children}
                </div>
            </div>
        </>
    )
}
// END
